import { Fragment, useState } from 'react'
import { useTranslation } from 'react-i18next'
import BulkUploadSparepartsModal from './BulkUploadSparepartsModal'
import SimpleButton from '../../common/SimpleButton'
import EmptyPageResults from '../../common/EmptyPageResults'
import { sparepartsUploadWritePermission } from '../../../utils/permissionValidation'
import '../uploads.scss'

const SpareParts = () => {
  const { t } = useTranslation()
  const [showBulkUploadModal, setShowBulkUploadModal] = useState(false)

  return (
    <Fragment>
      <div className="uploads-wrapper">
        <div className="actions-wrapper">
          <div />
          <SimpleButton className="submit-button" onClick={() => setShowBulkUploadModal(true)} requiredPermission={sparepartsUploadWritePermission}>
            {t('spareparts_upload_context.bulk_upload_spareparts')}
          </SimpleButton>
        </div>
        <EmptyPageResults title={t('spareparts_upload_context.coming_soon')} subtitle={t('spareparts_upload_context.coming_soon_subtitle')} />
      </div>
      {showBulkUploadModal && <BulkUploadSparepartsModal closeModal={() => setShowBulkUploadModal(false)} />}
    </Fragment>
  )
}

export default SpareParts
